import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Building2, Home, Users, Receipt, TrendingDown, TrendingUp, RefreshCw, FileText, Calendar, BarChart3, LogOut, Percent } from 'lucide-react'
import useAuthStore from '../store/authStore'
import useAppStore from '../store/appStore'

const navGroups = [
  { label: 'Principal', items: [
    { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  ]},
  { label: 'Configuração', items: [
    { to: '/condominios', icon: Building2, label: 'Condomínios' },
    { to: '/fracoes', icon: Home, label: 'Frações' },
    { to: '/condominos', icon: Users, label: 'Condóminos' },
  ]},
  { label: 'Financeiro', items: [
    { to: '/cc', icon: Receipt, label: 'Contas correntes' },
    { to: '/quotas', icon: Percent, label: 'Quotas' },
    { to: '/despesas', icon: TrendingDown, label: 'Despesas' },
    { to: '/receitas', icon: TrendingUp, label: 'Receitas' },
    { to: '/reconciliacao', icon: RefreshCw, label: 'Reconciliação' },
  ]},
  { label: 'Gestão', items: [
    { to: '/documentos', icon: FileText, label: 'Documentos' },
    { to: '/reunioes', icon: Calendar, label: 'Reuniões' },
    { to: '/relatorios', icon: BarChart3, label: 'Relatórios' },
  ]}
]

export default function Sidebar() {
  const { user, logout } = useAuthStore()
  const { condominios, condominioAtivo, setCondominioAtivo } = useAppStore()

  return (
    <aside style={{ width: 'var(--sidebar-w)', background: 'var(--surface)', borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
      <div style={{ padding: '16px', borderBottom: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 30, height: 30, background: 'var(--green)', borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Building2 size={16} color="#fff" />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 14 }}>CondoGest</div>
            <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>Gestão de condomínios</div>
          </div>
        </div>
      </div>

      <div style={{ padding: '10px 12px', borderBottom: '1px solid var(--border)' }}>
        <select className="form-select" style={{ fontSize: 12 }} value={condominioAtivo?.id || ''}
          onChange={e => { const c = condominios.find(c => c.id === e.target.value); if (c) setCondominioAtivo(c) }}>
          {condominios.length === 0 && <option value="">Sem condomínios</option>}
          {condominios.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      </div>

      <nav style={{ flex: 1, padding: '8px 0', overflowY: 'auto' }}>
        {navGroups.map(group => (
          <div key={group.label}>
            <div style={{ padding: '10px 14px 4px', fontSize: 10, fontWeight: 700, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              {group.label}
            </div>
            {group.items.map(item => (
              <NavLink key={item.to} to={item.to} style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px', margin: '1px 6px',
                borderRadius: 6, fontSize: 13,
                color: isActive ? 'var(--green-dark)' : 'var(--text-secondary)',
                background: isActive ? 'var(--green-light)' : 'transparent',
                fontWeight: isActive ? 600 : 400
              })}>
                <item.icon size={15} />
                {item.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div style={{ padding: '10px 12px', borderTop: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'var(--green-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: 'var(--green-dark)', flexShrink: 0 }}>
          {user?.nome?.substring(0, 2).toUpperCase()}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 12, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.nome}</div>
          <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{user?.role}</div>
        </div>
        <button onClick={logout} style={{ background: 'none', border: 'none', color: 'var(--text-secondary)', padding: 4 }} title="Sair">
          <LogOut size={15} />
        </button>
      </div>

      <div style={{ padding: '8px 12px', borderTop: '1px solid var(--border)', textAlign: 'center' }}>
        <div style={{ fontSize: 10, color: 'var(--text-tertiary)' }}>Desenvolvido por</div>
        <div style={{ fontSize: 11, fontWeight: 500, color: 'var(--text-secondary)' }}>António Neves</div>
      </div>
    </aside>
  )
}
